var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideReportBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66665 4.79167H5.74998C5.24165 4.79167 4.75414 4.9936 4.39469 5.35305C4.03525 5.71249 3.83331 6.2 3.83331 6.70833V18.2083C3.83331 18.7167 4.03525 19.2042 4.39469 19.5636C4.75414 19.9231 5.24165 20.125 5.74998 20.125H11.2096M7.66665 4.79167C7.66665 4.28334 7.86858 3.79582 8.22803 3.43638C8.58747 3.07693 9.07498 2.875 9.58331 2.875H11.5C12.0083 2.875 12.4958 3.07693 12.8553 3.43638C13.2147 3.79582 13.4166 4.28334 13.4166 4.79167M7.66665 4.79167C7.66665 5.3 7.86858 5.78751 8.22803 6.14695C8.58747 6.5064 9.07498 6.70833 9.58331 6.70833H11.5C12.0083 6.70833 12.4958 6.5064 12.8553 6.14695C13.2147 5.78751 13.4166 5.3 13.4166 4.79167M17.25 13.4167V17.25H21.0833M17.25 13.4167C18.2666 13.4167 19.2417 13.8205 19.9606 14.5394C20.6794 15.2583 21.0833 16.2333 21.0833 17.25M17.25 13.4167C16.2333 13.4167 15.2583 13.8205 14.5394 14.5394C13.8205 15.2583 13.4166 16.2333 13.4166 17.25C13.4166 18.2667 13.8205 19.2417 14.5394 19.9606C15.2583 20.6795 16.2333 21.0833 17.25 21.0833C18.2666 21.0833 19.2417 20.6795 19.9606 19.9606C20.6794 19.2417 21.0833 18.2667 21.0833 17.25M17.25 10.5417V6.70833C17.25 6.2 17.048 5.71249 16.6886 5.35305C16.3292 4.9936 15.8416 4.79167 15.3333 4.79167H13.4166M7.66665 10.5417H11.5M7.66665 14.375H10.5416",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideReportBlack);
export default __webpack_public_path__ + "static/media/sideReportBlack.8cb6d600fc52474dca4aed3832996420.svg";
export { ForwardRef as ReactComponent };